import { ITimeFormats } from 'apps/fleet-planner/utils/userDateTimeSettings'
import { stopDate, stopTime, stopTimeZone } from 'utils/appointmentHelpers'
import { FORMATS } from 'constants/datetime'

interface IStop {
  appointment?: {
    startAt?: string
    endAt?: string
    timezone?: string
    startAtTime?: string | null
  }
  facility?: { shipperFacilityUuid?: string }
}

export const selectedFacilityAppointmentTime = (
  stops: IStop[],
  detention: { shipperFacilityUuid: string },
  timeFormats: ITimeFormats
) => {
  const selectedFacilityStop = stops.find(
    stop => stop?.facility?.shipperFacilityUuid === detention.shipperFacilityUuid
  )
  const { endAt, startAt, startAtTime, timezone } = selectedFacilityStop?.appointment || {}
  const appointmentTime =
    stopTime(startAt, endAt, timezone, false, startAtTime, timeFormats.stopTimeInput) || ''
  const appointmentDate = stopDate(startAt, timezone, FORMATS.dateFormat)
  const appointmentTimezone = stopTimeZone(startAt, endAt, timezone)
  const appointmentDateTime = startAt
    ? `${appointmentDate} ${appointmentTime} ${appointmentTimezone}`
    : ''
  return appointmentDateTime
}
